import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'

import App from './App'
import reportWebVitals from './reportWebVitals'
import api from './api/api'
import apiGlobal from './api/global'
import './index.css'
import lang from './lang'
import { jumpToUCOpenservice } from './utils/function'
import { getUrlParams } from './utils/url'
import { getApiHost } from '../core-config'

const isComplete =
      process.env.REACT_APP_IS_COMPLETE === 'true' ||
      (process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_IS_DEBUG === 'false')

if(!isComplete){
  var script = document.createElement('script');
  script.src = process.env.PUBLIC_URL+'/JS/echarts.min.js';
  document.head.appendChild(script);
}

// 如果有?URI参数
// 1、本地退出登录（如有token）
// 2、重定向到URI指定的页面
const { impersonate_uri } = getUrlParams()
if (impersonate_uri) {
  const token = window.localStorage.getItem('sdwan-token') || ''
  if (token) {
    window.localStorage.removeItem('sdwan-token')
    apiGlobal.logout({ token }).then(() => {
      window.location.href = impersonate_uri
    })
  } else {
    window.location.href = impersonate_uri
  }
}

// 设置网页标题
document.title = process.env.REACT_APP_NAME || ''
// 非生产环境需要
if(process.env.NODE_ENV !== 'production') {
  window.localStorage.setItem('sdwan-hasAuth', 'hasAuth')
  window.localStorage.setItem('sdwan-token', 'token')
}
const { host, protocol } = window.location

window.IAM && window.IAM(
  'sdwan-token',
  process.env.REACT_APP_API_HOST || getApiHost(host, protocol), // 如果没设置apiHost
  ({ code, data }) => {
    if (data) {
    // 登录信息校验接口
    const { authUsers = [], authId: loginAuthId, member } = data
    // 更新authUsers
    window.localStorage.setItem('sdwan-authUsers', JSON.stringify(authUsers))
    // 更新当前菜单权限列表
    const authId = window.localStorage.getItem('sdwan-authId')
    window.localStorage.setItem('sdwan-loginAuthId', loginAuthId)
    window.localStorage.setItem('sdwan-memberRoles', member?.roles)
    window.localStorage.setItem('sdwan-memberLabel', `${member?.name}（${member?.cname}）`)
    const currentUser = authUsers.find((item: { aliasId: any }) => item.aliasId === authId)
    const currentMenus = currentUser?.auth?.menus || []
    if(currentMenus && Array.isArray(currentMenus)) {
      window.localStorage.setItem('sdwan-authMenu', JSON.stringify(currentMenus))
    }
    currentUser?.label && window.localStorage.setItem('sdwan-username', `${currentUser?.label}`)
    }
    return (code - 0) !== 44 ? '' : data.url
  },
  ({ data, code }) => {
    // 储存authUsers(可选用户列表)和authId（当前登录用户id）
    const { isChild, name, authUsers = [], authId, token, member } = data
    window.localStorage.setItem('sdwan-memberRoles', member?.roles)
    window.localStorage.setItem('sdwan-memberLabel', `${member?.name}（${member?.cname}）`)
    window.localStorage.setItem('sdwan-authUsers', JSON.stringify(authUsers))
    window.localStorage.setItem('sdwan-authId', authId)
    window.localStorage.setItem('sdwan-loginAuthId', authId)

    const currentUser = authUsers.find((item: { aliasId: any }) => item.aliasId === authId)
    window.localStorage.setItem('sdwan-username', `${currentUser?.label}` || lang.Common.UserName)
    // 是否是子用户
    if(isChild) {
      // 判断子用户权限(只读、可编辑)
      let childAuth = 'isChild'
      if(data?.readOnly == 1) {
        childAuth = 'readOnly'
      }
      window.localStorage.setItem('sdwan-isChild', childAuth)
    } else {
      window.localStorage.removeItem('sdwan-isChild')
    }

    // 菜单权限列表
    const currentMenus = authUsers.find((item: { aliasId: any }) => item.aliasId === authId)?.auth?.menus || []
    if(currentMenus && Array.isArray(currentMenus)) {
      window.localStorage.setItem('sdwan-authMenu', JSON.stringify(currentMenus))
    }

    // 如果code等于预期值 则需要跳转到联系客服页面
    if(code === 604) {
      window.localStorage.removeItem('sdwan-hasAuth')
      // 如果在canvas下则需跳转到uc/openService
      const isComplete = process.env.REACT_APP_IS_COMPLETE === 'true' || (process.env.NODE_ENV === 'development' && process.env.REACT_APP_IS_DEBUG === 'false')
      if(!isComplete) {
        // 接入统一平台
        jumpToUCOpenservice()
      }
    } else {
      // 如果不为604则设置sdwan-hasAuth
      window.localStorage.setItem('sdwan-hasAuth', 'hasAuth')
    }
    return token || ''
  },
  '/account/user/validate',
  '/account/user/iamView'
)
const loadRootComponent = () => window.login.then(() => {
  api.instance.defaults.headers.common.Authorization = `Bearer ${window.localStorage.getItem('sdwan-token')}`
  api.instance.defaults.headers.common['Accept-Language'] = window.localStorage.getItem('language')
  api.instance.defaults.headers.common['Auth-User'] = window.localStorage.getItem('sdwan-authId')
}).then(() => Promise.resolve<React.FC>(App))

if (
  (process.env.NODE_ENV === 'development' && process.env.REACT_APP_IS_DEBUG === 'false') ||
  (process.env.NODE_ENV === 'production' && process.env.REACT_APP_IS_COMPLETE === 'true')
) loadRootComponent().then(() => ReactDOM.render(<App />, document.getElementById('root')))

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent,
  errorBoundary(err, info, props) {
    // https://reactjs.org/docs/error-boundaries.html
    return <div>This renders when a catastrophic error occurs</div>
  },
})

export const bootstrap = reactLifecycles.bootstrap

export const mount = [
  window.dynamicLink?.mount(
    process.env.REACT_APP_CSS_TAG!,
    process.env.PUBLIC_URL,
    process.env.NODE_ENV
  ),
  reactLifecycles.mount
]

export const unmount = [
  reactLifecycles.unmount,
  window.dynamicLink?.unmount(process.env.REACT_APP_CSS_TAG!)
]

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
